export function TransactionMailIcon({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="26"
        height="64"
        viewBox="0 0 26 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 7.5C23.4853 7.5 25.5 9.51472 25.5 12V52C25.5 54.4853 23.4853 56.5 21 56.5H0.5V7.5H21Z"
          fill="currentColor"
        />
        <path
          d="M21 7.5C23.4853 7.5 25.5 9.51472 25.5 12V52C25.5 54.4853 23.4853 56.5 21 56.5H0.5V7.5H21Z"
          stroke="currentColor"
        />
        <path
          d="M16.75 38.375H9.25C7 38.375 5.5 37.25 5.5 34.625V29.375C5.5 26.75 7 25.625 9.25 25.625H16.75C19 25.625 20.5 26.75 20.5 29.375V34.625C20.5 37.25 19 38.375 16.75 38.375Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.75 29.75L14.4025 31.625C13.63 32.24 12.3625 32.24 11.59 31.625L9.25 29.75"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M0 0C0 3.86599 3.13401 7 7 7H0V0Z" fill="currentColor" />
        <path d="M0 64C0 60.134 3.13401 57 7 57H0V64Z" fill="currentColor" />
      </svg>
    </span>
  );
}
